import loadable from '@loadable/component';

export const UserDashboardProfessionalExperiencePageLoadable = loadable(
  () => import('./UserDashboardProfessionalExperiencePage'),
  {
    resolveComponent: (module) =>
      module.UserDashboardProfessionalExperiencePage,
  },
);
